module.exports = __webpack_public_path__ + "static/img/7965_phase_function_Paper_PointsHejduk_Prediction.ec12046.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/7965_phase_function_Paper_PointsHejduk_Prediction.png
// module id = z1cq
// module chunks = 0